<script>
  import { onMount } from "svelte";
  import Card from "./Card.svelte";
  import {
    SetupStore,
    ItemsStore
  } from "../stores/gameStore";
  import { ItemMeta } from "../../constants/items";
  import {
    getTextsSkills,
    getTextsItemLables
  } from "../../constants/allTexts";

  export let card, id, width, enhanced, location = 'none';

  const textsSkills = getTextsSkills();
  const textsItemLables = getTextsItemLables();
  const textClass = _('Class');
  const textEnhanced = _('Enhanced');

  $: _card =
    enhanced == 1
      ? {
          ...card,
          ...card.enhanced,
          type: "ITEM_BACK",
        }
      : { ...card, type: "ITEM_FRONT" };

  let idStandard = ''.concat(id, '_', location);
  let idEnhanced = ''.concat(id, '_', location, '_enhanced');
  let card_id = idStandard;
  $: if (enhanced != 0) {
    card_id = idEnhanced;
  }

  onMount(() => {
    createTooltips();
  });

  let trackChanges = $ItemsStore[id].slot;
  let trackChanges2 = id;
  let trackChanges3 = enhanced;
  let delayTimeout;
  $: if ((trackChanges !== $ItemsStore[id].slot) || (trackChanges2 !== id) || (trackChanges3 != enhanced)) {
    trackChanges = $ItemsStore[id].slot;
    trackChanges2 = id;
    trackChanges3 = enhanced;

    // Clear any existing timeout to avoid multiple triggers
    if (delayTimeout) {
      clearTimeout(delayTimeout);
    }
    window.GAME.removeTooltip(idStandard);
    window.GAME.removeTooltip(idEnhanced);
    idStandard = ''.concat(id, '_', location);
    idEnhanced = ''.concat(id, '_', location, '_enhanced');
    card_id = idStandard;
    if (enhanced != 0) {
      card_id = idEnhanced;
    }
    
    // Delay the tooltip creation
    delayTimeout = setTimeout(() => {
      createTooltips();
    }, 100);
  }

  $: cardData = $SetupStore.data.cards[id];

  function createTooltips() {
    const scaleFactor = 0.65;
    const frontBackgroundWidth = 2494 * scaleFactor;
    const frontBackgroundHeight = 2140  * scaleFactor;
    const frontCardsX = 9; // Width of each card in Amount of Cards
    const frontCardsY = 5; // Height of each card in Amount of Cards
    let frontCardWidth = frontBackgroundWidth / frontCardsX;
    let frontCardHeigth = frontBackgroundHeight / frontCardsY;
    window.GAME.addTooltipHtml(
      idStandard,
      `<div style="display:flex; flex-direction:column; margin: 1rem;">
        <div 
          style="
            display: flex; 
            justify-content: center;">
          <div 
            style="
              background-image: url('${g_gamethemeurl}img/CardsItemsFront.jpg');
              background-position: -${card.offset[1] * frontCardWidth}px -${card.offset[0] * frontCardHeigth}px;
              width: ${frontCardWidth}px;
              height: ${frontCardHeigth}px;
              background-size: ${frontBackgroundWidth}px ${frontBackgroundHeight}px;
              margin-bottom: 1rem;
              border-radius: 15px;
              filter: drop-shadow(0 0 0.75rem rgb(0, 0, 0, 0.5));
            ">
          </div>
        </div>
        <div style="width:100%;display:flex; justify-content:space-between; align-items:center; gap:2rem;">
          <div class="headline">${textsItemLables[cardData.position || "UNDEFINED"]}</div>
            <div 
              style="
                background: ${ItemMeta[cardData.position || "UNDEFINED"].color};
                box-shadow: 0px 1px 4px 0px rgba(0,0,0,.6);
                font-weight: bold;
                border-radius: 10px; /* Rounded corners */
                padding: 0.2rem 0.6rem; /* Add padding for dynamic sizing */
                display: inline-flex; /* Inline-flex to size dynamically and center content */
                justify-content: center;
                align-items: center;
              ">
              <div 
                style="
                  font-size: 0.8rem;
                  white-space: nowrap; /* Prevent wrapping */
                ">
                ${textClass} ${cardData.level}
              </div>
            </div>
          </div>
          <hr style="width:100%;"/>
          <div style="display:flex; flex-direction:column; gap:0.5rem;">
            ${cardData.combat.skills.map((c) => `
              <div style="display:flex; flex-direction:row; justify-content:space-between; align-items:center;">
                <div style="display:flex; flex-direction:row; gap:0.5rem; align-items:center;">
                  <div style="width:2ch; text-align:right; color: ${c.value === 0 ? "rgb(120,120,120)" : "inherit"};">
                    ${c.value !== undefined && c.value !== 0 ? c.value : ""}
                  </div>
                  <div style="margin-left:0.3rem; color: ${c.value === 0 ? "rgb(120,120,120)" : "inherit"};">
                    ${textsSkills[c.type]?.name}
                  </div>
                </div>
                <div style="margin-left:0.5rem; color: rgb(120,120,120); font-size:1rem;">
                  ${c.enhanced !== undefined ? c.enhanced : ""}
                </div>
              </div>
            `).join("")}
          </div>
        </div>`
    );
    if (cardData.level != 1) {
      const backBackgroundWidth = 1664 * scaleFactor;
      const backBackgroundHeight = 2140  * scaleFactor;
      const backCardsX = 6; // Width of each card in Amount of Cards
      const backCardsY = 5; // Height of each card in Amount of Cards
      let backCardWidth = backBackgroundWidth / backCardsX;
      let backCardHeigth = backBackgroundHeight / backCardsY;
      window.GAME.addTooltipHtml(
      idEnhanced,
      `<div style="display:flex; flex-direction:column; margin: 1rem;">
        <div 
          style="
            display: flex; 
            justify-content: center;">
          <div 
            <div 
              style="
                background-image: url('${g_gamethemeurl}img/CardsItemsBack.jpg');
                background-position: -${card.enhanced.offset[1] * backCardWidth}px -${card.enhanced.offset[0] * backCardHeigth}px;
                width: ${backCardWidth}px;
                height: ${backCardHeigth}px;
                background-size: ${backBackgroundWidth}px ${backBackgroundHeight}px;
                margin-bottom: 1rem;
                border-radius: 15px;
                filter: drop-shadow(0 0 0.75rem rgb(0, 0, 0, 0.5));
              ">
          </div>
        </div>
        <div style="width:100%;display:flex; justify-content:space-between; align-items:center; gap:2rem;">
          <div class="headline">${textsItemLables[cardData.position || "UNDEFINED"]}</div>
            <div 
              style="
                background: rgb(251,226,82);
                box-shadow: 0px 1px 4px 0px rgba(0,0,0,.6);
                font-weight: bold;
                border-radius: 10px; /* Rounded corners */
                padding: 0.2rem 0.6rem; /* Add padding for dynamic sizing */
                display: inline-flex; /* Inline-flex to size dynamically and center content */
                justify-content: center;
                align-items: center;
              ">
              <div 
                style="
                  font-size: 0.8rem;
                  white-space: nowrap; /* Prevent wrapping */
                ">
                ${textEnhanced}
              </div>
            </div>
            <div 
              style="
                background: ${ItemMeta[cardData.position || "UNDEFINED"].color};
                box-shadow: 0px 1px 4px 0px rgba(0,0,0,.6);
                font-weight: bold;
                border-radius: 10px; /* Rounded corners */
                padding: 0.2rem 0.6rem; /* Add padding for dynamic sizing */
                display: inline-flex; /* Inline-flex to size dynamically and center content */
                justify-content: center;
                align-items: center;
              ">
              <div 
                style="
                  font-size: 0.8rem;
                  white-space: nowrap; /* Prevent wrapping */
                ">
                ${textClass} ${cardData.level}
              </div>
            </div>
          </div>
          <hr style="width:100%;"/>
          <div style="display:grid; grid-template-columns:auto 1fr; grid-column-gap:0.5rem">
          ${cardData.enhanced.combat.skills.map((c) => `<div>${c.value !== undefined ? c.value + " " : ""}</div><div>${textsSkills[c.type]?.name}</div>`).join("")}
          </div>
         </div>`
      );
    }
  }
</script>

<!-- <pre>{JSON.stringify(card.offset, null, 2)}</pre> -->
<Card {...$$props} {width} card={_card} id={card_id} />

<style>
</style>
